import { useEffect, useState } from 'react';
import type { MailFolderType } from '@/types/components';
import type { MailMessage } from '@/types/mail';

export const useMailSelection = (
  visibleMails: MailMessage[],
  folderType: MailFolderType,
) => {
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const areAllSelected =
    visibleMails.length > 0 && selectedIds.size === visibleMails.length;

  const startSelecting = () => setIsSelecting(true);

  const toggleSelect = (id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);

      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedIds(
      areAllSelected ? new Set() : new Set(visibleMails.map((m) => m.id)),
    );
  };

  const exitSelection = () => {
    setIsSelecting(false);
    setSelectedIds(new Set());
  };

  useEffect(() => {
    setIsSelecting(false);
    setSelectedIds(new Set());
  }, [folderType]);

  return {
    isSelecting,
    selectedIds,
    areAllSelected,
    startSelecting,
    toggleSelect,
    toggleSelectAll,
    exitSelection,
  };
};
